
<div class="actions" *ngIf="actions$|async as actions">
  <div class="action" *ngFor="let action of actions">{{action.event }} - {{action.data |json}} - {{action.created_at}}</div>
</div>

<div class="menu">
  <app-subscription-menu></app-subscription-menu>
</div>
<button (click)="clickNotification()">Notification Email</button>
